// eslint-disable-next-line import/order
import { RouteRecordRaw } from 'vue-router';

// eslint-disable-next-line import/order
import { showUIKit } from 'SharedDir/modules/ProjectComponents/ui-kit';
import { authorizedOnly } from 'SharedDir/router/helpers';

import { routerInitialPath, routerMainPageName } from 'PortalDir/router/router.constants';
import Auth from 'src/router/routes/auth';
import Issues from 'src/router/routes/issues';
import News from 'src/router/routes/news';
import Profile from 'src/router/routes/profile';
import Projects from 'src/router/routes/projects';
import Service from 'src/router/routes/service';
import UsefulLinks from 'src/router/routes/useful-links';
import Information from 'src/router/routes/information';
import Search from 'src/router/routes/search';

const MainLayout = () => import(/* webpackChunkName: "MainLayout" */ 'layouts/MainLayout.vue');
const AuthLayout = () => import(/* webpackChunkName: "AuthLayout" */ 'layouts/AuthLayout.vue');
const EmptyLayout = () => import(/* webpackChunkName: "EmptyLayout" */ 'layouts/EmptyLayout.vue');

const RouterViewComponent = () =>
  import(/* webpackChunkName: "RouterViewComponent" */ 'SharedDir/layouts/RouterViewComponent.vue');

const routes: RouteRecordRaw[] = [
  {
    path: routerInitialPath,
    component: MainLayout,
    children: showUIKit([
      {
        path: '',
        name: routerMainPageName,
        component: () => import('PortalDir/modules/Main/pages/IndexPage.vue'),
      },
      {
        path: '',
        name: 'login',
        props: { openLoginModal: true },
        component: () => import('PortalDir/modules/Main/pages/IndexPage.vue'),
      },
      {
        path: 'contacts',
        name: 'contacts',
        component: () => import('PortalDir/modules/Contacts/pages/List.vue'),
      },
      {
        path: 'language-center',
        name: 'language-center',
        component: () => import('PortalDir/modules/LanguageCenter/pages/Index.vue'),
      },
      {
        path: 'services',
        component: RouterViewComponent,
        children: Service,
      },
      {
        path: 'news',
        component: RouterViewComponent,
        children: News,
      },
      {
        path: 'useful-links',
        component: RouterViewComponent,
        children: UsefulLinks,
      },
      {
        path: 'profile',
        component: RouterViewComponent,
        meta: { noSsr: true },
        children: Profile,
      },
      {
        path: 'issues',
        component: RouterViewComponent,
        meta: { noSsr: true, ...authorizedOnly() },
        children: Issues,
      },
      {
        path: 'projects',
        component: RouterViewComponent,
        children: Projects,
      },
      ...Search,
    ]),
  },
  {
    path: '/auth',
    component: AuthLayout,
    children: Auth,
  },
  {
    path: '/information',
    component: EmptyLayout,
    children: Information,
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('PortalDir/modules/Errors/ErrorNotFound.vue'),
  },
];

export default routes;
